import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, Router } from '@angular/router';
import { ABMRolesService, CuentasService, NavigationService } from '../../../services';
import { Location } from '@angular/common';
import { PATH_ABM, PATH_AGENDA } from '../../../navigation/navigation.module';
import { PermisosService } from '../../../services/permisos-service';

@Component({
  selector: 'app-acopio-detail',
  templateUrl: './acopio-detail.component.html',
  styleUrls: ['./acopio-detail.component.scss']
})
export class AcopioDetailComponent implements OnInit, OnDestroy {

  private acopioId;
  public acopio: any = {};

  public categorias = [];

  public carSelected = 0;

  empresasPage = 0;
  empresasResponseData = [];
  empresasSubject$ = new BehaviorSubject<any[]>([]);

  empresasShowSelected = true;
  empresasShowUnselected = true;

  loadedSecondTab = false;

  private scrollSubscriber;

  @ViewChild('acopioNameInput') acopioNameInput;

  constructor(private route: ActivatedRoute,
              private location: Location,
              private abmService: ABMRolesService,
              private cuentasService: CuentasService,
              private router: Router,
              private navService: NavigationService,
              private permisosService: PermisosService) {
    this.permisosService.verificarAccesoDeURL();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.acopioId = this.route.snapshot.params['id'];

      this.loadData();
    });
  }

  loadData(){

    if (this.acopioId){
      this.abmService.getAcopios()
        .subscribe(data => {
          this.acopio = data.find(d => d.Id === Number(this.acopioId));

          this.getCategorias();
          this.getEmpresas();
        });
    } else {
      this.acopio = this.abmService.getTmpAcopio();
      if (!this.acopio) {
      	this.acopio = {
          "AcopioNombre": '',
          "CuentasIds": [],
          "CategoriaId": 1,
          "ParentId": null
        };
        this.router.navigate([PATH_ABM]);
      }
      this.getCategorias();
      this.getEmpresas();
    }
  }

  onNavigateBack(){
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/'+PATH_ABM+'/acopios');
    }
  }

  getCategorias(){
    this.abmService.getCategorias()
      .subscribe(data => {
        this.categorias = data;
      });
  }

  getEmpresas(page?: number){
    this.cuentasService.getEmpresas(page)
      .subscribe( data => {
        this.empresasResponseData = [ ...this.empresasResponseData, ...data.map(e => {
          e.checked = this.acopio.CuentasIds.indexOf(e.Id)>=0;
          return e;
        }) ];
        this.empresasSubject$.next(this.empresasResponseData);
      });
  }

  onSubmit(){
    // in edit mode do not remove the cuentas that were already assigned to it, even if we haven't checked them because they might not be in sight
    this.acopio.CuentasIds = [...this.acopio.CuentasIds, ...this.empresasResponseData.filter(e => e.checked).map(e => e.Id)];
    this.acopio.CuentasIds = this.acopio.CuentasIds.filter(e => {
      let tmp = this.empresasResponseData.find(a => a.Id === e);
      return !tmp || tmp.checked !== false
    }).sort((a, b) => a-b).filter((e, i, a) => a.indexOf(e) === i);  // removing duplicates

    if (this.acopioId) {
      this.abmService.updateAcopio(this.acopio).subscribe(
        data => {
          this.router.navigate([PATH_ABM + '/acopios']);
      });
    } else {
      this.abmService.createAcopio(this.acopio).subscribe(
        data => {
          this.abmService.setTmpAcopio(null);
          this.router.navigate([PATH_ABM + '/acopios']);
      });
    }
  }

  onEmpresaChecked(empresa, e) {
    empresa.checked = e.checked;
  }

  onSelectAll() {
    this.empresasResponseData.forEach(e => e.checked = true);
  }

  onDeselectAll() {
    this.empresasResponseData.forEach(e => e.checked = false);
  }

  onSelectedTabChange($event) {
    if (!this.loadedSecondTab) {
      this.setupPagination();
      this.loadedSecondTab = true;
    }
  }

  setupPagination() {
    const content = document.getElementById('empresas-container');

    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        console.log(x);
        let max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7){
          this.empresasPage++;
          this.getEmpresas(this.empresasPage);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/acopio-detail/acopio-detail.component.ts